



















Hello = require './components/Hello'
LineC = require './components/Line'
Instrument = require './components/Instrument'



module.exports = {
    name: 'app',
    components: {
        Hello, LineC, Instrument
    }
    data: -> {
        time: -1
        res: 16
        isPlaying: false
        instruments: 1
        bpm: 80
        globalTranspose: 0
    }
    methods: {
        nextTick: () ->
            if !(this.isPlaying)
                this.time = -1
                return
            timeBetweenBeats = (60 * 1000) / (this.bpm * this.res)
            this.time = (this.time + 1)
            # console.log this.time
            self = this
            setTimeout(
                () -> self.nextTick(),
                timeBetweenBeats)
        togglePlay: () ->
            if this.time == -1
                this.isPlaying = true
                this.nextTick()
            else
                this.time == -1
                this.isPlaying = false
    }

}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue